import React, { useState } from "react";
import {
  Box,
  Typography,
  Container,
  Button,
  IconButton,
  TextField,
  InputAdornment,
  CircularProgress,
} from "@mui/material";
import {
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
  Close as CloseIcon,
  PasswordRounded,
} from "@mui/icons-material";

import { useAppContext } from "../context/AppContext";
import { changePassword } from "../helpers/Authentication";
import Toast from "./toast";

const ChangePassword = ({ HandleClose }) => {
  const { isMobile, isSmallMobile } = useAppContext();

  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSave = async () => {
    const User = localStorage.getItem("User");
    const user_ = JSON.parse(User);
    const userID = user_?.UserInfo?.id;

    if (password !== confirmPassword) {
      Toast.error("Password and Confirm Password should match!");
      return;
    }
    setIsLoading(true);
    const response = await changePassword({
      userID: userID,
      password: password,
    });
    if (response.Status_Code === 200 && response.IsSuccess === true) {
      Toast.success(response.message);
      HandleClose();
    } else {
      Toast.error(response.message);
    }
    setIsLoading(false);
  };

  return (
    <Container
      style={{
        backgroundColor: "#303030",
        width: isMobile ? "90%" : "40%",
        borderRadius: "10px",
      }}
    >
      <div
        style={{
          p: 2,
          borderBottom: "1px solid #444",
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          textAlign: "center",
          padding: "8px 0px",
        }}
      >
        <Typography fontSize={"32px"} color="#ffffff" width={"100%"}>
          Chane Password
        </Typography>
        <IconButton
          onClick={() => HandleClose()}
          sx={{ color: "#999", ml: "auto" }}
        >
          <CloseIcon />
        </IconButton>
      </div>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "20px 10px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            my: "5px",
          }}
        >
          <PasswordRounded sx={{ color: "#ffffff", mr: 1, my: 0.5 }} />
          <TextField
            fullWidth
            label="Password"
            type={showPassword ? "text" : "password"}
            placeholder="••••••••"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    sx={{ color: "#666" }}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            inputProps={{
              autoComplete: "off",
              style: {
                WebkitBoxShadow: "0 0 0 1000px #333 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff",
                border: "none", // ← Add this
                outline: "none", // ← Add this too
              },
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: "#333",
                color: "#fff",
                minHeight: "56px",
                "& fieldset": { borderColor: "#444" },
                "&:hover fieldset": { borderColor: "#ccc" },
                "&.Mui-focused fieldset": { borderColor: "#ccc" },
              },
              "& .MuiInputLabel-root": {
                color: "#fff !important",
                "&.Mui-focused": {
                  color: "#fff !important",
                },
                "&.MuiInputLabel-shrink": {
                  color: "#fff !important",
                },
              },
              "& .MuiInputBase-input": {
                color: "#fff",
                backgroundColor: "#333 !important",
                border: "none !important", // ← Add this for extra safety
              },
              "& .MuiInputBase-input::placeholder": {
                color: "#666",
                opacity: 1,
              },
            }}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            my: "5px",
          }}
        >
          <PasswordRounded sx={{ color: "#ffffff", mr: 1, my: 0.5 }} />

          <TextField
            fullWidth
            label="Re-enter Password"
            type={showConfirmPassword ? "text" : "password"}
            placeholder="••••••••"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    sx={{ color: "#666" }}
                    edge="end"
                  >
                    {showConfirmPassword ? (
                      <VisibilityOffIcon />
                    ) : (
                      <VisibilityIcon />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            inputProps={{
              autoComplete: "off",
              style: {
                WebkitBoxShadow: "0 0 0 1000px #333 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff",
                border: "none", // ← Add this
                outline: "none", // ← Add this too
              },
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: "#333",
                color: "#fff",
                minHeight: "56px",
                "& fieldset": { borderColor: "#444" },
                "&:hover fieldset": { borderColor: "#ccc" },
                "&.Mui-focused fieldset": { borderColor: "#ccc" },
              },
              "& .MuiInputLabel-root": {
                color: "#fff !important",
                "&.Mui-focused": {
                  color: "#fff !important",
                },
                "&.MuiInputLabel-shrink": {
                  color: "#fff !important",
                },
              },
              "& .MuiInputBase-input": {
                color: "#fff",
                backgroundColor: "#333 !important",
                border: "none !important", // ← Add this for extra safety
              },
              "& .MuiInputBase-input::placeholder": {
                color: "#666",
                opacity: 1,
              },
            }}
          />
        </Box>
        <Button
          variant="contained"
          onClick={() => {
            handleSave("login");
          }}
          sx={{
            backgroundColor: "#6366f1",
            borderRadius: "8px",
            padding: "3px",
            width: "80px",
            fontSize: "1rem",
            fontWeight: 600,
            textTransform: "none",
            mt: 1,
            "&:hover": { backgroundColor: "#5855eb" },
          }}
        >
          {isLoading === true ? (
            <CircularProgress color="#5855eb" size={"24px"} />
          ) : (
            "Save"
          )}
        </Button>
      </Box>
    </Container>
  );
};

export default ChangePassword;
